<template>
    <contract-filters-controller v-slot:default="cfc" v-bind:requestfilter="elpc.requestfilter" v-bind:resetfilters="elpc.routereset" v-bind:types="elpc.dictionaries.types" v-on:filters:update="elpc.processRequestUpdate">
        <div class="atmo-entity-filters">
            <form id="form-purchase-filters" class="atmo-form">
                <fieldset class="atmo-group atmo-mobile">
                    <div class="atmo-form__field">
                        <multiselect
                            id="purchase-deliverables-groups"
                            v-model="cfc.deliverablesgroups"
                            :options="elpc.dictionaries.deliverablesgroups"
                            :multiple="true"
                            :allow-empty="true"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :show-labels="false"
                            :placeholder="'Выберите предметы закупки'"
                            v-on:select="cfc.processDictionaryFilterUpdate($event, 'add', 'purchaseCategories')"
                            v-on:remove="cfc.processDictionaryFilterUpdate($event, 'remove', 'purchaseCategories')"
                            label="title"
                            track-by="id">
                            <span slot="noOptions">Нет данных.</span>
                            <span slot="noResult">Записей, соответствующих вашему запросу, не найдено.</span>
                        </multiselect>

                        <label for="purchase-deliverables-groups">Предметы закупки</label>
                    </div>

                    <!-- // DEPRECATED:; -->
                    <!-- <div class="atmo-form__field">
                        <input v-model="cfc.filters.purchaseName" type="text" id="purchase-purchaseName"
                            placeholder="Укажите предмет закупки" autocomplete="off">
                        <label for="purchase-purchaseName">Предмет закупки</label>
                    </div> -->

                    <div class="atmo-form__field">
                        <input v-model="cfc.filters.conditionname" type="text" id="purchase-conditionname" placeholder="Укажите наименование ТРУ" autocomplete="off" />
                        <label for="purchase-conditionname">Наименование ТРУ</label>
                    </div>
                </fieldset>

                <fieldset v-show="cfc.isFiltersVisible" class="atmo-group atmo-tablet">
                    <div class="atmo-form__field">
                        <input v-model="cfc.filters.regNumber" type="text" id="purchase-regNumber" placeholder="Укажите номер закупки" autocomplete="off" />
                        <label for="purchase-regNumber">Регистрационный номер закупки</label>
                    </div>

                    <div class="atmo-form__field">
                        <input v-model="cfc.filters.customer" type="text" id="purchase-customer" placeholder="Укажите наименование/ИНН заказчика" autocomplete="off" />
                        <label for="purchase-customer">Заказчик</label>
                    </div>

                    <div class="atmo-form__field">
                        <input v-model="cfc.filters.provider" type="text" id="purchase-provider" placeholder="Укажите наименование/ИНН поставщика" autocomplete="off" />
                        <label for="purchase-provider">Поставщик</label>
                    </div>

                    <div class="atmo-form__field">
                        <dropdown-select v-slot:default="ds" v-bind:list="cfc.types" v-bind:initialid="cfc.contracttype.currentid" v-bind:currentid="cfc.contracttype.currentid" v-on:dropdown:select:selected="cfc.manageSelection">
                            <on-off v-slot:default="onoff">
                                <div class="atmo-dropdown-select">
                                    <button type="button" v-on:click.stop="onoff.toggle">
                                        <span v-if="!ds.hasSelected">Любой</span>
                                        <span v-if="ds.hasSelected" v-html="ds.text"></span>
                                    </button>
                                    <ul v-show="onoff.ison" class="atmo-dropdown">
                                        <li v-on:click="ds.clear">Любой</li>
                                        <li v-for="item in ds.list" v-bind:key="item.id" v-on:click="ds.select(item.id)">
                                            <span v-html="item.title"></span>
                                        </li>
                                    </ul>
                                </div>
                            </on-off>
                        </dropdown-select>

                        <label for="purchase-contracttype">Тип контракта</label>
                    </div>
                </fieldset>

                <fieldset v-show="cfc.isFiltersVisible" class="atmo-group atmo-tablet">
                    <div class="atmo-form__field">
                        <currency-input v-model="cfc.filters.fromStartPrice" currency="RUB" locale="ru" v-bind:allow-negative="false" v-bind:precision="0" type="text" id="purchase-fromStartPrice" placeholder="НЦК от..." autocomplete="off"> </currency-input>
                        <label for="purchase-fromStartPrice">НЦК от...</label>
                    </div>

                    <div class="atmo-form__field">
                        <currency-input v-model="cfc.filters.toStartPrice" currency="RUB" locale="ru" v-bind:allow-negative="false" v-bind:precision="0" type="text" id="purchase-toStartPrice" placeholder="НЦК до..." autocomplete="off"> </currency-input>
                        <label for="purchase-toStartPrice">НЦК до...</label>
                    </div>

                    <div class="atmo-form__field">
                        <!-- <input v-model="cfc.filters.orderDateStart"
                            type="text" id="purchase-orderDateStart"
                            placeholder="Укажите дату проведения с" autocomplete="off"> -->

                        <date-picker
                            v-model="cfc.filters.fromPurchaseStart"
                            id="purchase-fromPurchaseStart"
                            label="Укажите дату размещения с"
                            button-now-translation="Сегодня"
                            format="YYYY-MM-DD"
                            formatted="DD.MM.YYYY"
                            v-bind:max-date="cfc.filters.toPurchaseStart"
                            v-bind:no-label="!!cfc.filters.fromPurchaseStart"
                            v-bind:auto-close="true"
                            v-bind:only-date="true">
                        </date-picker>
                        <label for="purchase-fromPurchaseStart-input">Дата размещения с...</label>
                    </div>

                    <div class="atmo-form__field">
                        <!-- <input v-model="cfc.filters.orderDateFinish" type="text" id="purchase-orderDateFinish"
                            placeholder="Укажите дату размещения по" autocomplete="off"> -->

                        <date-picker
                            v-model="cfc.filters.toPurchaseStart"
                            id="purchase-toPurchaseStart"
                            label="Укажите дату размещения по"
                            button-now-translation="Сегодня"
                            format="YYYY-MM-DD"
                            formatted="DD.MM.YYYY"
                            v-bind:min-date="cfc.filters.fromPurchaseStart"
                            v-bind:no-label="!!cfc.filters.toPurchaseStart"
                            v-bind:auto-close="true"
                            v-bind:only-date="true">
                        </date-picker>
                        <label for="purchase-toPurchaseStart-input">Дата размещения по...</label>
                    </div>
                </fieldset>

                <fieldset v-show="cfc.isFiltersVisible" class="atmo-group atmo-tablet">
                    <div class="atmo-form__field">
                        <multiselect
                            id="purchase-municipalities"
                            v-model="cfc.municipalities"
                            :options="elpc.dictionaries.municipalities"
                            :multiple="true"
                            :allow-empty="true"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :show-labels="false"
                            :placeholder="'Выберите муниципалитет'"
                            v-on:select="cfc.processDictionaryFilterUpdate($event, 'add', 'municipalities')"
                            v-on:remove="cfc.processDictionaryFilterUpdate($event, 'remove', 'municipalities')"
                            label="title"
                            track-by="id">
                            <span slot="noOptions">Нет данных.</span>
                            <span slot="noResult">Записей, соответствующих вашему запросу, не найдено.</span>
                        </multiselect>

                        <label for="purchase-municipalities">Муниципалитеты</label>
                    </div>
                </fieldset>
            </form>

            <!-- REFACTOR: Extract the block into the separate universal view. -->
            <!-- Make it for purchases list page as well. -->
            <ul class="atmo-buttons atmo-special atmo-mobile">
                <li>
                    <button v-bind:disabled="!cfc.hasFiltersChanged" v-on:click="cfc.search" class="atmo-button-inverse">Найти</button>
                </li>
                <li>
                    <button v-on:click="cfc.toggleFilters" class="atmo-button-border-only">
                        <span v-if="!cfc.isFiltersVisible">Все фильтры</span>
                        <span v-if="cfc.isFiltersVisible">Меньше фильтров</span>
                    </button>
                </li>
                <li>
                    <button v-bind:disabled="cfc.isFiltersEmpty" v-on:click="cfc.reset" class="atmo-button-border-only">Сбросить</button>
                </li>
            </ul>
        </div>
    </contract-filters-controller>
</template>

<script>
import { CurrencyInput } from 'vue-currency-input';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import DropdownSelect from '@lib/js/src/vue/components/DropdownSelect.viewmodel.ts';
import OnOff from '@lib/js/src/vue/components/OnOffV6.component.js';

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import ContractFiltersController from '@core/js/viewmodels/contracts/ContractFiltersController.viewmodel.ts';

export default {
    props: {
        elpc: { required: true, type: Object }
    },
    components: {
        CurrencyInput,
        'date-picker': VueCtkDateTimePicker,
        'contract-filters-controller': ContractFiltersController,
        'dropdown-select': DropdownSelect,
        'on-off': new OnOff()
    }
};
</script>
